import styled from 'styled-components'
import { breakpoint } from 'utils/consts/breakpoints'

export const Wrapper = styled.div`
  display: flex;
  overflow: hidden;
  flex: 1;
  position: relative;

  @media ${breakpoint.s} {
    touch-action: pan-x;
  }
`

export const ImagesContainer = styled.div<{
  translateX: number
  gap: number
}>`
  display: flex;
  gap: ${props => props.gap}px;
  transform: translateX(${props => props.translateX}px);
  transition: transform 0.3s ease;
`

export const ImageItem = styled.div<{
  size: number
  isActive: boolean
}>`
  width: ${props => props.size}px;
  height: ${props => props.size}px;
  flex-shrink: 0;
  cursor: pointer;
  border: 1px solid
    ${props => (props.isActive ? 'var(--color-velvet)' : 'var(--color-sw-10)')};
  border-radius: 8px;
  overflow: hidden;
  opacity: ${props => (props.isActive ? 1 : 0.7)};
  transition: all 0.3s ease;
  padding: 3px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;

  &:hover {
    opacity: 1;
  }

  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
    border-radius: 4px;
  }
`
